const configReducer = (state, { type, payload }) => {
    switch (type) {
        case 'LOGIN':
            return state;

        default:
            return state;
    }
};

export default configReducer;
